<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado
        v-if="encabezado"
        :elementos="encabezado"
        :action="action"
        :isViewDetailsForm="isViewDetailsForm"
      />
      <v-card class="border-card-gray">
        <v-card-text>
          <div
            name="table"
            v-if="showAction(1) && table"
            :class="[list.length < 6 ? 'calendar' : '']"
            class="mt-2 ml-2 mr-2"
          >
            <v-row class="mb-2" dense>
              <v-col cols="3" md="3" sm="3" v-if="filterModality">
                <branch-offices-list
                :model="idBranchOfficeSelected"
                  v-on:triggerChange="branchOfficeSelected"
                />
              </v-col>
              <v-col cols="3" md="3" sm="3" v-if="filterDate">
                <vc-date-picker
                  color="green"
                  v-model="range"
                  is-range
                  :max-date="new Date()"
                >
                  <template v-slot="{ inputEvents }">
                    <v-text-field
                      v-on="inputEvents.start"
                      :value="rangeComputed"
                      :append-icon="validData ? 'mdi-eraser' : 'mdi-calendar'"
                      @click:append="clearCalendar"
                      :disabled-input="validData"
                      :label="labelDate || 'Seleccione fecha...'"
                      single-line
                      outlinedx
                      hide-details
                    ></v-text-field>
                  </template>
                </vc-date-picker>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  outlinedx
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="2"
                class="d-flex justify-center mt-4"
                v-if="!hideButtonAdd"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      @click="changeAction(2)"
                      v-bind="attrs"
                      v-on="on"
                      block
                    >
                      <v-icon left>{{addButtonIcon}}</v-icon>
                      {{ addButtonText }}
                    </v-btn>
                  </template>
                  <span>{{ addButtonText }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <component
              key="table"
              :get="get"
              :deleteItem="deleteItem"
              :listAllPagination="listAllPagination"
              :idBranchOffice="idBranchOfficeSelected"
              :updateStatus="updateStatus"
              :list="list"
              :is="table"
              :search="search"
              :currentPage="currentPage"
              :range="range"
              :totalCount="totalCount"
              @isViewDetails="isViewDetails"
            />
            <v-row dense>
              <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                <paginatesx
                  :click-handler="changePage"
                  :page-count="pageCount"
                  :page-range="1"
                  :margin-pages="1"
                  :prev-text="'<'"
                  :next-text="'>'"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                >
                </paginatesx>
              </v-col>
              <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                <v-banner outlined single-line>
                  Total: {{ totalCount }}</v-banner
                >
              </v-col>
            </v-row>
          </div>

          <div name="form" v-if="(showAction(2) || showAction(3)) && form">
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent="undefined" class="mt-8 ml-8 mr-8">
                <component
                  :is="form"
                  key="form"
                  :model="model"
                  :modelList="modelList"
                  :idMedicalPractice="idMedicalPractice"
                  @returnTable="returnTable"
                  :isViewDetailsForm="isViewDetailsForm"
                  :saveCie10Changes="saveCie10Changes"
                  :updatetoModel="updatetoModel"
                  :takePictureAudiometry="takePictureAudiometry"
                   @onFilesSelected="setSelectedFiles"
                />
                <div class="separator20-50">
                  <v-divider></v-divider>
                </div>

                <div class="text-center justify-center">
                  <v-col class=" justify-space-around">
                    <v-menu
                      offset-x
                      bottom
                      left
                      :close-on-content-click="true"
                      rounded="lg"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mr-12 mb-4"
                          :disabled="sending"
                          outlined
                          color="error"
                          depressed
                          v-bind="attrs"
                          v-on="{ ...menu }"
                          @click="confirmationReturn()"
                        >
                          <v-icon left>  mdi-chevron-left </v-icon>
                          Volver
                        </v-btn>
                      </template>
                    </v-menu>
                    <v-menu
                      offset-x
                      bottom
                      rigth
                      :close-on-content-click="true"
                      rounded="lg"
                      v-if="isViewDetailsForm == false"
                    >
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn
                          type="button"
                          class="mb-4"
                          :disabled="invalid"
                          v-bind="attrs"
                          depressed
                          v-on="{ ...menu }"
                          color="primary"
                          @click="confirmationSave()"
                        >
                          {{ saveButtonText }}
                          <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </div>
              </v-form>
            </validation-observer>
          </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="swalDialog" persistent></v-dialog>
      <v-dialog
        persistent
        max-width="300px"
        transition="dialog-top-transition"
        v-model="addWithPDF"
      >
        <v-card>
          <v-card-title class="text-h6 text-center">
            Visualización de reportes
          </v-card-title>
          <v-container>
            <v-row style="padding: 10px">
              <v-col class="text-center">
                <v-btn
                  width="100%"
                  outlined
                  color="error"
                  :disabled="sending"
                  @click="exportToPdf()"
                >
                  Consulta {{ namePDF }}
                  <v-icon right>mdi-file-pdf-box</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" text @click="returnTable()">
                Salir <v-icon right>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import moment from "moment";
import BranchOfficesList from "@/components/BranchOfficesList.vue";


export default {
  name: "CrudView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      labelDate: null,
      cols: "col-md-3 col-xl-3 col-sm-12",
      idBranchOffice: null,
      sending: false,
      dialog: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      modelList: {
        idReferenceValue: 0,
        value: "",
      },
      encabezado: null,
      table: null,
      service: null,
      form: null,
      pdfModal: null,
      cancelationDialog: null,
      search: null,
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      filterDate: false,
      filterModality: false,
      cancelationModal: false,
      generatePDFModal: false,
      saveButtonText: "",
      addButtonText: "",
      addButtonIcon: "",
      addWithPDF: false,
      range: null,
      idBranchOfficeSelected: null,
      idMedicalPractice: "",
      isViewDetailsForm: false,
      saveCie10Changes: false,
      swalDialog: false,
      namePDF: "",
      updatetoModel: false,
      takePictureAudiometry: false,
      fromTelemedicineToStart: false,
      fromTelemedicineHistory: false,
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },
    idBranchOfficeState() {
      this.listAllPagination();
    },
  },
  async mounted() {
    this.service = (await this.$route.meta.service()).default;
    this.table = (await this.$route.meta.table()).default;
    this.form = (await this.$route.meta.form()).default;
    this.encabezado = this.$route.meta.header;
    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.filterDate = this.$route.meta.filterDate || false;
    this.filterModality = this.$route.meta.filterModality || false;
    this.cancelationModal = this.$route.meta.cancelationModal || false;
    this.generatePDFModal = this.$route.meta.generatePDFModal || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";
    this.addButtonIcon = this.$route.meta.addButtonIcon || "mdi-home";
    this.labelDate = this.$route.meta.labelDate || "Seleccione fecha";
    this.namePDF = this.$route.meta.namePDF || "general";
    this.listAllPagination();
    this.validTab();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),

    rangeComputed() {
      if (
        this.range === null ||
        this.range === "" ||
        this.range === undefined
      ) {
        return "";
      }
      return `Del ${this.$utilFront.formatDate(
        this.range.start
      )} al ${this.$utilFront.formatDate(this.range.end)}`;
    },
    validData() {
      if (this.range == "" || this.range == null || this.range == undefined) {
        return false;
      }
      this.listAllPagination();
      return true;
    },
  },
  methods: {
    ...mapActions(["validTab"]),
    // ...mapActions(["updateBranchOffice", "updateAction"]),
    confirmationReturn() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea regresar a la vista principal?",
        // html: "¿Desea <b>regresar</b> a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;

          this.changeAction(1);
        } else {
          this.swalDialog = false;
        }
      });
    },
    confirmationSave() {
      this.takePictureAudiometry = true;
      this.saveCie10Changes = true;
      this.updatetoModel = true;
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar el registro actual?",
        // html: "¿Desea <b>guardar</b> el registro actual? ",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.saveCie10Changes = false;
          this.updatetoModel = false;
          this.swalDialog = false;
          this.takePictureAudiometry = false;
          this.doAction();
        } else {
          this.swalDialog = false;
          this.takePictureAudiometry = false;
        }
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    returnTable() {
      this.addWithPDF = false;
      this.changeAction(1);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        // this.$refs.observer.reset();
        this.model = {};
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
  const modulo = this.$route.meta.module;
  switch (this.action) {
    case 2:
      if (modulo === "telemedicina") {
        this.addTelemedicineDiagnosis();
      } else {
        this.add();
      }
      break;
    case 3: 
      if (modulo === "telemedicina") {
        this.updateTelemedicineDiagnosis();
      } else {
        this.update();
      }
      break;
  }
},


    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      this.sending = true;
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      if (this.$utilFront.nonEmpty(this.range)) {
        params.start = this.$utilFront.startOfDay(this.range.start);
        params.end = this.$utilFront.endOfDay(this.range.end);
      }

      this.service
        .listAllPagination(params)
        .then((res) => {
          this.sending = false;
          let { list, count } = res.data;
          this.list = list;
          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);

          if (
            (count > 0 &&
              this.$utilFront.isEmptyList(list) &&
              this.currentPage > 1) ||
            this.currentPage > this.pageCount
          ) {
            this.changePage(1);
          }
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    buildPayload() {
      const modulo = this.$route.meta.module;
      switch (modulo) {
        case "telemedicina":
          return {
            idMedicalPractice: this.model.idMedicalPractice,
            cie10List: Array.isArray(this.model.cie10List) ? this.model.cie10List : [],
            content: this.model.content,
            diagnosticDetail: this.model.diagnosticDetail,
            idHumanResource: this.model.idHumanResource,
            subsequent: this.model.subsequent,
            telemedicineFiles: Array.isArray(this.model.telemedicineFiles)
              ? this.model.telemedicineFiles.map(file => ({
                  fileName: file.fileName,
                  base64: file.base64,
                }))
              : [],
          };

        case "psicologia":
          return {
            idMedicalPractice: this.model.idMedicalPractice,
            idPatient: this.model.idPatient,
            idAppointment: this.model.idAppointment,
            gender: this.model.gender,
            birthDate: this.model.birthDate,
            vitalSigns: this.model.vitalSigns,
            antecedents: this.model.antecedents,
            cie10List: this.model.cie10List,
            content: this.model.content,
            diagnosticDetail: this.model.diagnosticDetail,
            orderStudies: this.model.orderStudies,
            prescriptionProducts: this.model.prescriptionProducts,
            idPrescription: this.model.idPrescription,
            canCancelPrescription: this.model.canCancelPrescription,
            statusTextPrescription: this.model.statusTextPrescription,
            idHumanResource: this.model.idHumanResource,
            subsequent: this.model.subsequent,
            referencePapSmear: this.model.referencePapSmear,
            questionnaireAttachments: this.model.questionnaireAttachments,
          };

        case "optometria":
          return {
            idMedicalPractice: this.model.idMedicalPractice,
            idPatient: this.model.idPatient,
            idAppointment: this.model.idAppointment,
            gender: this.model.gender,
            birthDate: this.model.birthDate,
            vitalSigns: this.model.vitalSigns,
            antecedents: this.model.antecedents,
            cie10List: this.model.cie10List,
            content: this.model.content,
            diagnosticDetail: this.model.diagnosticDetail,
            orderStudies: this.model.orderStudies,
            prescriptionProducts: this.model.prescriptionProducts,
            idPrescription: this.model.idPrescription,
            canCancelPrescription: this.model.canCancelPrescription,
            statusTextPrescription: this.model.statusTextPrescription,
            idHumanResource: this.model.idHumanResource,
            subsequent: this.model.subsequent,
            referencePapSmear: this.model.referencePapSmear,
            questionnaireAttachments: this.model.questionnaireAttachments,
            procedures: this.model.procedures,     
    evaluations: this.model.evaluations,      
    glassesRequest: this.model.glassesRequest
          };

        case "audiometria":
          return {
            idMedicalPractice: this.model.idMedicalPractice,
            idPatient: this.model.idPatient,
            idAppointment: this.model.idAppointment,
            gender: this.model.gender,
            birthDate: this.model.birthDate,
            vitalSigns: this.model.vitalSigns,
            antecedents: this.model.antecedents,
            cie10List: this.model.cie10List,
            content: this.model.content,
            diagnosticDetail: this.model.diagnosticDetail,
            orderStudies: this.model.orderStudies,
            prescriptionProducts: this.model.prescriptionProducts,
            idPrescription: this.model.idPrescription,
            canCancelPrescription: this.model.canCancelPrescription,
            statusTextPrescription: this.model.statusTextPrescription,
            idHumanResource: this.model.idHumanResource,
            subsequent: this.model.subsequent,
            referencePapSmear: this.model.referencePapSmear,
            questionnaireAttachments: this.model.questionnaireAttachments,
            symptoms: this.model.symptoms,                   
            evaluationsBodyElement: this.model.evaluationsBodyElement, 
            resultsTest: this.model.resultsTest,             
            audiometryTest: this.model.audiometryTest,       
            audiometryGraphImage: this.model.audiometryGraphImage 
          };

        default:
          return this.model;
      }
    },
    addwithPDF() {
  let payload;

  if (this.fromTelemedicineToStart) {
    payload = {
      idMedicalPractice: this.model.idMedicalPractice,
      cie10List: Array.isArray(this.model.cie10List)
        ? this.model.cie10List
        : [],
      content: this.model.content,
      diagnosticDetail: this.model.diagnosticDetail,
      idHumanResource: this.model.idHumanResource,
      subsequent: this.model.subsequent,
      telemedicineFiles: Array.isArray(this.model.telemedicineFiles)
        ? this.model.telemedicineFiles.map((file) => ({
            fileName: file.fileName,
            base64: file.base64
          }))
        : []
    };
  } else {
    
    payload = {
      idMedicalPractice: this.model.idMedicalPractice,
      idPatient: this.model.idPatient,
      vitalSigns: this.model.vitalSigns,
    };
  }

  this.sending = true;
  this.service
    .add(payload)
    .then((response) => {
      this.sending = false;
      let { data, status } = response;
      if (status === 200) {
        this.listAllPagination();
        this.takePictureAudiometry = false;
        this.$utilFront.notifications(
          "Se ha atendido correctamente.",
          "SUCCESS"
        );
        this.addWithPDF = true;
      } else {
        data = data || "Ocurrió un error durante el registro.";
        this.$utilFront.notifications(data, "ERROR");
      }
    })
    .catch((e) => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},
add() {
      const payload = this.buildPayload();
      this.sending = true;
      this.service
        .add(payload)
        .then(response => {
          this.sending = false;
          const { data, status } = response;
          if (status === 200) {
            this.listAllPagination();
            this.takePictureAudiometry = false;
            this.$utilFront.notifications("Se ha atendido correctamente.", "SUCCESS");
            this.addWithPDF = true;
          } else {
            this.$utilFront.notifications(data || "Ocurrió un error durante el registro.", "ERROR");
          }
        })
        .catch(e => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    updateWithPDF() {
    this.sending = true;

    let payload;
    if (this.fromTelemedicineHistory) {
      payload = {
        idMedicalPractice: this.model.idMedicalPractice,
        cie10List: Array.isArray(this.model.cie10List) ? this.model.cie10List : [],
        content: this.model.content,
        diagnosticDetail: this.model.diagnosticDetail,
        idHumanResource: this.model.idHumanResource,
        subsequent: this.model.subsequent,
        telemedicineFiles: Array.isArray(this.model.telemedicineFiles)
          ? this.model.telemedicineFiles.map((file) => ({
              fileName: file.fileName,
              base64: file.base64,
            }))
          : [],
      };
    } else {
      payload = {
        idMedicalPractice: this.model.idMedicalPractice,
        idPatient: this.model.idPatient,
        vitalSigns: this.model.vitalSigns,
      };
    }

    this.service
      .update(payload)
      .then((response) => {
        this.sending = false;
        let { data, status } = response;
        if (status === 200) {
          this.addWithPDF = true;
          this.$utilFront.notifications("Se ha modificado correctamente.", "SUCCESS");
        } else {
          data = data || "Ocurrió un error durante la modificación.";
          this.$utilFront.notifications(data, "ERROR");
        }
      })
      .catch((e) => {
        this.sending = false;
        this.$utilFront.errorhttp(e);
      });
  },


addTelemedicineDiagnosis() {
  const payload = {
    idMedicalPractice: this.model.idMedicalPractice,
    cie10List: Array.isArray(this.model.cie10List) ? this.model.cie10List : [],
    content: this.model.content,
    diagnosticDetail: this.model.diagnosticDetail,
    idHumanResource: this.model.idHumanResource,
    subsequent: this.model.subsequent,
  };

  this.sending = true;
  this.service
    .add(payload)
    .then(response => {
      this.sending = false;
      if (response.status === 200) {
        this.$utilFront.notifications("Diagnóstico guardado correctamente.", "SUCCESS");
        if (this.model.telemedicineFiles && this.model.telemedicineFiles.length > 0) {
          this.addTelemedicineFiles();
        } else {
          this.listAllPagination();
          this.changeAction(1);
        }
      } else {
        this.$utilFront.notifications(response.data || "Error al guardar diagnóstico.", "ERROR");
      }
    })
    .catch(e => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},

 addTelemedicineFiles() {
  const jsonData = {
    idMedicalPractice: this.model.idMedicalPractice,
  };

  const formData = new FormData();
  formData.append("jsonData", JSON.stringify(jsonData));

  if (this.model.telemedicineFiles && this.model.telemedicineFiles.length > 0) {
    for (const fileItem of this.model.telemedicineFiles) {
      if (fileItem.base64 && fileItem.fileName) {
        const fileBlob = this.base64ToBlob(fileItem.base64, fileItem.fileName);
        formData.append("files", fileBlob, fileItem.fileName);
      }
    }
  }
  
  this.sending = true;
  this.service
    .saveFilesTelemedicine(formData)
    .then(response => {
      this.sending = false;
      if (response.status === 200) {
        this.$utilFront.notifications("Archivos guardados correctamente.", "SUCCESS");
        this.listAllPagination();
        this.changeAction(1);
      } else {
        this.$utilFront.notifications(response.data || "Error al guardar archivos.", "ERROR");
      }
    })
    .catch(e => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},

updateTelemedicine() {
  const jsonData = {
    idPatient: this.model.idPatient,
    idClinicalEvent: this.model.idClinicalEvent,
    idMedicalPractice: this.model.idMedicalPractice,
  };

  const formData = new FormData();
  formData.append("jsonData", JSON.stringify(jsonData));

  if (this.model.telemedicineFiles && this.model.telemedicineFiles.length > 0) {
    for (const file of this.model.telemedicineFiles) {
      if (file.base64 && file.fileName) {
        // Convertimos base64 a Blob antes de adjuntarlo
        const fileBlob = this.base64ToBlob(file.base64, file.fileName);
        formData.append("files", fileBlob, file.fileName);
      }
    }
  } else {
  }

  this.sending = true;
  this.service
    .updateMultipart(formData)
    .then((response) => {
      this.sending = false;
      if (response.status === 200) {
        this.$utilFront.notifications("Se ha modificado correctamente.", "SUCCESS");
        this.listAllPagination();
        this.changeAction(1);
      } else {
        this.$utilFront.notifications(response.data || "Error al actualizar.", "ERROR");
      }
    })
    .catch((e) => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},

base64ToBlob(base64Data, fileName) {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  let mimeType = "application/octet-stream";
  const ext = fileName.split(".").pop().toLowerCase();
  if (ext === "png") mimeType = "image/png";
  else if (ext === "jpg" || ext === "jpeg") mimeType = "image/jpeg";
  else if (ext === "pdf") mimeType = "application/pdf";
  else if (ext === "doc") mimeType = "application/msword";
  else if (ext === "docx") {
    mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  }

  return new Blob(byteArrays, { type: mimeType });
},

updateTelemedicineDiagnosis() {
  const diagnosisPayload = {
    idMedicalPractice: this.model.idMedicalPractice,
    cie10List: Array.isArray(this.model.cie10List) ? this.model.cie10List : [],
    content: this.model.content,
    diagnosticDetail: this.model.diagnosticDetail,
    idHumanResource: this.model.idHumanResource,
    subsequent: this.model.subsequent,
  };

  this.sending = true;
  this.service.updateDiagnosis(diagnosisPayload)
    .then(response => {
      this.sending = false;
      if (response.status === 200) {
        this.updateTelemedicineFiles();
      } else {
        this.$utilFront.notifications(response.data || "Error al actualizar el diagnóstico.", "ERROR");
      }
    })
    .catch(e => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},


updateTelemedicineFiles() {
  const jsonData = {
    idPatient: this.model.idPatient,
    idClinicalEvent: this.model.idClinicalEvent,
    idMedicalPractice: this.model.idMedicalPractice,
  };

  const formData = new FormData();
  formData.append("jsonData", JSON.stringify(jsonData));

  if (this.model.telemedicineFiles && this.model.telemedicineFiles.length > 0) {
    for (const file of this.model.telemedicineFiles) {
      if (file.base64 && file.fileName) {
        const fileBlob = this.base64ToBlob(file.base64, file.fileName);
        formData.append("files", fileBlob, file.fileName);
      }
    }
  }

  this.sending = true;
  this.service
    .updateMultipart(formData)
    .then((response) => {
      this.sending = false;
      if (response.status === 200) {
        this.$utilFront.notifications("Se ha modificado correctamente.", "SUCCESS");
        this.listAllPagination();
        this.changeAction(1);
      } else {
        this.$utilFront.notifications(response.data || "Error al actualizar.", "ERROR");
      }
    })
    .catch((e) => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},

  update() {
  const payload = this.buildPayload();
  this.sending = true;
  this.service
    .update(payload)
    .then(response => {
      this.sending = false;
      const { data, status } = response;
      if (status === 200) {
        this.listAllPagination();
        this.$utilFront.notifications("Se ha modificado correctamente.", "SUCCESS");
        this.changeAction(1);
      } else {
        this.$utilFront.notifications(data || "Ocurrió un error durante la modificación.", "ERROR");
      }
    })
    .catch(e => {
      this.sending = false;
      this.$utilFront.errorhttp(e);
    });
},
    isViewDetails(e) {
      this.isViewDetailsForm = e;
    },
    get(params, i, fromTelemedicineToStart, fromTelemedicineHistory) {
  this.fromTelemedicineToStart = fromTelemedicineToStart;
  this.fromTelemedicineHistory = fromTelemedicineHistory;


  this.model = {};            

  if (!this.sending) {
    this.sending = true;
    this.idMedicalPractice = params;

    let data = {
      idMedicalPractice: params,
    };


    
    this.service
      .get(data)
      .then((responseTelemed) => {
        let { data, status } = responseTelemed;
        if (status === 200) {
          this.model = data;


          if (this.model.telemedicineFiles && this.model.telemedicineFiles.length) {
    this.model.telemedicineFiles = this.model.telemedicineFiles.map(file => {
      return {
        ...file,
        base64: file.bytes ? file.bytes.replace(/\r?\n/g, "") : file.base64
      };
    });
  }

  const modulo = this.$route.meta.module;
    if (modulo === "telemedicina") {
      this.model.patientAge = this.getAge(this.model.birthDate);
    } else {
      delete this.model.patientAge;
    }
          if (fromTelemedicineHistory) {
            return this.service.getColposcopy({ idMedicalPractice: params });
          } else {
            
            return null;
          }
        } else {
          data = data || "Ocurrió un error al obtener la info Telemedicina.";
          this.$utilFront.notifications(data, "ERROR");
        }
      })
      .then((responseColpos) => {
        if (!responseColpos) return;

        let { data, status } = responseColpos;
        if (status === 200) {
         
          this.model = {
            ...this.model,
            ...data,
          };
          
        } else {  
          data = data || "Ocurrió un error al obtener la info Colposcopia.";
          this.$utilFront.notifications(data, "ERROR");
        }
      })
      .catch((e) => {
        this.$utilFront.errorhttp(e);
      })
      .finally(() => {
        this.sending = false;
        this.changeAction(i);
      });
  }
},

getAge(birthDateMillis) {
    if (!birthDateMillis) return 0;
    const now = new Date();
    const birthDate = new Date(birthDateMillis);
 
    let age = now.getFullYear() - birthDate.getFullYear();
    const monthDiff = now.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  },


    deleteItem(params, i) {
      if (this.cancelationModal) {
        this.listAllPagination();
      } else if (!this.sending) {
        this.sending = true;

        this.service
          .delete(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.list.splice(i, 1);
              this.totalCount--;

              if (this.totalCount >= this.itemsPerPage) {
                this.listAllPagination();
              }

              this.$utilFront.notifications(
                "Se ha eliminado correctamente.",
                "SUCCESS"
              );
            } else {
              data = data || "Ocurrió un error al eliminar la información.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    exportToPdf() {
  this.sending = true;
  if (this.model.idMedicalPractice) {
    const fileName = `Consulta_${this.namePDF}_${
      this.model.idMedicalPractice9
    }_${moment(new Date()).format("YYYY-MM-DD")}`;

    // Armar el objeto data base
    const data = {
      fileName: fileName,
      idBranchOffice: this.$utilFront.getIdBranchOffice(),
      idPatient: this.model.idPatient,
      idMedicalPractice: this.model.idMedicalPractice,
    };

    // Si el módulo es telemedicina, se añade el campo type
    if (this.$route.meta.module === "telemedicina") {
      data.type = 1;
    }

    this.service
      .pdf(data)
      .then((res) => {
        if (res.status === 200 && res.data.type !== "application/json") {
          this.$utilFront.openPDF(res.data);
        } else {
          this.$utilFront.notifications("No se pudo generar el reporte.", "ERROR");
          this.$utilFront.displayErrorPdf(res.data);
        }
      })
      .finally(() => {
        this.sending = false;
      });
  }
},
    updateStatus(params, i) {
      if (!this.sending) {
        this.sending = true;

        this.service
          .updateStatus(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.$utilFront.notifications(
                "Se ha modificado correctamente.",
                "SUCCESS"
              );
              this.listAllPagination();
            } else {
              data = data || "Ocurrió un error durante la modificación.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    clearCalendar() {
      this.range = "";
      this.listAllPagination();
    },
  },
};
</script>
